import styled from "styled-components";
import fondo from "../../images/ProjectBackground.jpg";

export const ProjectSection = styled.div`
  padding-top: 100px;
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ light }) => (light ? "white" : "#0a0806")};
`;

export const ProjectSectionDes = styled.p`
  text-align: center;
  margin-bottom: 40px;
  color: ${({ light }) => (light ? "black" : "#5dc1b9")};
  font-size: 22px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  max-width: 90%;
  margin-right: auto;
  margin-left: auto;
`;

export const ProjectContainer = styled.div`
  max-width: 90%;
  margin-right: auto;
  margin-left: auto;
  border-radius: 20px;
  padding-bottom: 40px;
`;

export const ProjectWrapper = styled.div`
  width: 100%;

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;

    @media screen and (max-width: 960px) {
      width: 250px;
      height: auto;
    }
  }

  .swiper-container {
    width: 80%;
    transform: translateX(-50%);
    z-index: 2;
    padding-bottom: 3vw;
    padding-top: 3vw;
    left: 40%;

    @media screen and (max-width: 960px) {
      padding-bottom: 8vw;
    }
  }

  .swiper-pagination-fraction {
    bottom: 0;
  }

  .swiper-pagination-bullet {
    width: 30px;
    height: 6px;
    border-radius: 5px;
    background: ${({ light }) => (light ? " #e57373" : " #52b2bf")};
    @media screen and (max-width: 960px) {
      width: 20px;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    color: ${({ light }) => (light ? "#e53935" : " #52b2bf")};
    @media screen and (max-width: 960px) {
    }
  }
`;

export const ProjectHeading = styled.h1`
  color: ${({ light }) => (light ? " #c62828" : " #52b2bf")};
  font-size: 80px;
  margin-bottom: 40px;
  letter-spacing: 0.5px;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  text-align: center;
  &:hover {
    transition: all 0.4s ease-out;
    transform: scale(1.3);
  }
  @media screen and (max-width: 820px) {
    font-size: 50px;
  }
`;

export const ProjectLink = styled.a`
  text-decoration: none;
`;

export const ProjectCard = styled.div`
  margin-bottom: 20px;
  border: 2px solid  ${({ light }) => (light ? "#8b0000" : "#497e76")};
  background: linear-gradient(rgb(17, 17, 17, 0.3), rgb(17, 17, 17, 0.3)),
    url(${fondo}) no-repeat;

 

    @media screen and (max-width: 1015px) {
      /*width: 250px;
      display: flex;
      justify-content: center;*/
      @media screen and (max-width: 820px) {
      margin-top: 30px;
  
    }
  
    }
   
  }
`;

export const ProjectCardMeta = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px;
`;

export const ProjectCardElements = styled.div`
  color: ${({ light }) => (light ? "#e0e0e0" : "white")};
  display: flex;
  flex-direction: column;
  font-weight: bold;
  font-size: 13px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid ${({ light }) => (light ? " #e57373" : " #5dc1b9")};
`;

export const ProjectCardElement = styled.p`
  font-size: 12px;
  font-weight: normal;
  margin-left: 5px;
  color: #;
  @media screen and (max-width: 960px) {
    font-size: 10px;
  }
`;

export const ProjectCardDivElement = styled.div`
  display: flex;
  text-align: center;
  align-items: flex-end;

  @media screen and (max-width: 960px) {
    font-size: 12px;
  }
`;

export const ProjectCardTitle = styled.h1`
  font-size: 18px;
  text-align: center;
  color: ${({ light }) => (light ? "#e53935" : "#80d8ff")};
  font-weight: bold;
  font-family: cursive;
  margin-bottom: 10px;
`;
export const ProjectCardSubTitle = styled.h4`
  font-size: 14px;
  color: ${({ light }) => (light ? "white" : "#bdbdbd")};
  margin-bottom: 10px;
  text-align: center;
`;

export const ProjectCardSubTitleBorder = styled.h4`
  border-bottom: 2px solid ${({ light }) => (light ? " #e57373" : " #5dc1b9")};
`;
export const ProjectCardDesc = styled.p`
  margin-top: 10px;
  font-size: 13.5px;
  color: ${({ light }) => (light ? "#bdbdbd" : "#f7f8fa")};
`;

export const ProjectCardButtons = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 14px;
  justify-content: center;
  align-items: center;
  height: 130px;
`;

export const AppButton = styled.button`
  width: 190px;
  border-radius: 5px;
  background: transparent;
  white-space: nowrap;
  padding: 10px 64px;
  font-size: 16px;
  outline: none;
  cursor: pointer;
  font-weight: bold;
  border: 3px solid ${({ light }) => (light ? " #8b0000" : " #42a8a1")};
  color: ${({ light }) => (light ? " #e57373" : " #42a8a1")};
  margin-bottom: 5px;

  &.active {
    background: #5dc1b9;
    color: #0a0a0a;
    transition: all 0.6s ease-out;
  }

  &:hover {
    transition: all 0.6s ease-out;
    background: ${({ light }) => (light ? " #e57373" : " #42a8a1")};
    color: #0a0a0a;
  }
`;
